import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAgentAuth } from '../../contexts/AgentAuthContext';

const ProtectedAgentRoute = ({ children }) => {
  const { agent, loading } = useAgentAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div id="agent-route-loading" className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center">
        <div id="loading-container" className="text-center">
          <div className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center mx-auto mb-4">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
          <p className="text-gray-600 text-sm">
            Verifying authentication...
          </p>
        </div>
      </div>
    );
  }

  // Redirect to agent login if not authenticated
  if (!agent) {
    return (
      <Navigate 
        to="/agent/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // Render protected content
  return children;
};

export default ProtectedAgentRoute;